import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core'
import { MdSnackBar, MdDialog, MdDialogRef } from '@angular/material'
import { Router, ActivatedRoute, Params } from '@angular/router'

import { UserService as UserServiceDeprecated } from '../../core/users/user.service'
import { UserService } from '../../users/shared/user.service'
import { AuthService } from '../../auth/auth.service'
import { ConversationService } from '../../core/conversation/conversation.service'
import { DialogService } from '../../dialog/shared/dialog.service'
import { ReportOptionsDialogComponent } from '../report-options-dialog/report-options-dialog.component'
import { ReportTextDialogComponent } from '../report-text-dialog/report-text-dialog.component'
import { AudioService } from '../../shared/shared.module'
import { TranslateService } from '@ngx-translate/core'

import { User } from '../../users/shared/user.model'
import { MovieService, Movie } from '../../movies/movies.module'
import { ReportOption } from '../shared/report-option.enum'

import { Observable } from 'rxjs/Observable'

@Component({
  moduleId: module.id,
  selector: 'cm-user-profile',
  templateUrl: 'user-profile.component.html',
  styleUrls: ['user-profile.component.css']
})
export class UserProfileComponent implements OnInit, AfterViewInit {

  user: User
  movies$: Observable<Movie[]>

  modalHeight = 0

  @ViewChild('content')
  private contentRef: ElementRef

  constructor(private userService: UserService,
    private movieService: MovieService,
    private userServiceDeprecated: UserServiceDeprecated,
    private conversationService: ConversationService,
    private authService: AuthService,
    private audioService: AudioService,
    private dialogService: DialogService,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MdSnackBar,
    private dialog: MdDialog) { }

  ngOnInit() {
    const uid = this.authService.currentUser.uid

    const currentUserLocation$ = this.userService.getUserLocation(uid)

    this.route.params
      .subscribe((params: Params) => {
        const otherUserUid = params['id']

        this.userService.getUserLocation(uid)
          .then((latLng: number[]) => {
            this.userService.getUser(otherUserUid, latLng)
              .subscribe((user: User) => {
                this.user = user
              })
          })

      })
    // Observable
    //   .forkJoin([this.route.params.take(1), currentUserLocation$])
    //   .mergeMap((result: any[]) => {
    //     const params = result[0]
    //     const currentUserLocation = result[1]

    //     console.log(result)
    //     return this.userService.getUser(params['id'], currentUserLocation)
    //   })
    //   .subscribe((user: User) => {
    //     this.user = user
    //   })

    this.route.params
      .subscribe((params: Params) => {
        const otherUserUid = params['id']


        this.movies$ = this.movieService.getMovieInterests(otherUserUid)
      })

      // .switchMap(result => {
      //   const id = result[0]['id']
      //   const user = result[1]

      //   user.location$
      //   return this.userService.getUser(id, user.location$)
      // })
      // .subscribe(user => this.user = user)

    // this.route.params
    //   .switchMap((params: Params) => this.userServiceDeprecated.getInterestedMovies(params['id']))
    //   .subscribe((movies: Movie[]) => this.movies = movies)
  }

  // getBannerUrl(url) {
  //   if (!url.startsWith('http://')) {
  //     url = 'http://developer.tmsimg.com/' + url + '?api_key=9h6jvc6de4ez8xwy53khs5bw'
  //   }

  //   return url
  // }

  sendInvitation(movie?: Movie) {
    const senderUid = this.authService.currentUser.uid
    this.userService.getUser(senderUid)
      .first()
      .subscribe((currentUser: User) => {
        const credits = currentUser.credits
        // Check if the current user has enough credits to send an invitation
        if (credits <= 0) {
          const snackbarRef = this.snackBar.open('Plus de crédits :(', null, {
            duration: 5000
          })
          snackbarRef.onAction().subscribe(() => {
            this.router.navigate(['shop'])
          })
        } else {
          const receiverUid = this.user.uid
          this.conversationService.createConversation(senderUid, receiverUid, movie)
            .then(() => {
              let message = this.translate.instant('inviteSent')

              if (!currentUser.isSubscribed()) {
                message += ` - ${credits - 1} ${this.translate.instant('invitesLeft')}`
              }

              const snackbarRef = this.snackBar.open(message, null, {
                duration: 3000
              })
            })
        }
      })

    this.audioService.playSound('../../../assets/sounds/ticket_tear.wav')
  }

  ngAfterViewInit() {
    this.modalHeight = this.getModalHeight()
  }

  report() {
    const dialogRef = this.dialog.open(ReportOptionsDialogComponent)
    dialogRef.afterClosed().subscribe((selectedOption: ReportOption) => {
      if (selectedOption === ReportOption.Other) {
        const textDialogRef = this.dialog.open(ReportTextDialogComponent)
        textDialogRef.afterClosed().subscribe((text: string) => {
          if (text) {
            this.userServiceDeprecated.reportUser(this.authService.currentUser.uid, this.user.uid, selectedOption, text)
          }
        })
      } else if (selectedOption !== undefined) {
        this.userServiceDeprecated.reportUser(this.authService.currentUser.uid, this.user.uid, selectedOption)
      }
    })
  }

  block() {
    this.dialogService
      .confirm('Bloquer l\'utilisateur', `Êtes-vous sur de vouloir bloquer l'utilisateur ${this.user.firstname} ?`)
      .subscribe((result: boolean) => {
        if (result === true) {
          this.userService.blockUser(this.authService.currentUser.uid, this.user.uid)
            .then(() => {
              this.router.navigateByUrl('/')
            })
        }
      })
  }

  onResize(event: any) {
    this.modalHeight = this.getModalHeight()
  }

  private getModalHeight(): number {
    return this.contentRef.nativeElement.clientHeight * 0.70
  }

  // back() {
  //   window.history.back()
  // }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/user-profile/user-profile.component.ts